// auth.js
import { API_URL } from "../../utils/config";
const baseUrl = API_URL;

const getLangFromLocalStorage = () => {
  return localStorage.getItem("language") || "en";
};

const defaultHeaders = () => ({
  "Content-Type": "application/json",
  "lang": getLangFromLocalStorage(),
});

export const login = async (values) => {
  console.log("Logging in with values:", baseUrl);
  const response = await fetch(`${baseUrl}/api/v1/attnd-supplier/auth/login`, {
    method: "POST",
    credentials: "include",
    headers: defaultHeaders(),
    body: JSON.stringify(values),
  });
  const data = await response.json();
  if (!response.ok) {
    const error = new Error("Login failed");
    error.response = data;
    throw error;
  }
  return { data, status: response.status };
};

export const resetPasswordRequest = async (values) => {
  const response = await fetch(`${baseUrl}/api/v1/attnd-supplier/auth/forget-password`, {
    method: "POST",
    credentials: "include",
    headers: defaultHeaders(),
    body: JSON.stringify(values),
  });
  const data = await response.json();
  if (!response.ok) {
    const error = new Error("Reset password request failed");
    error.response = data;
    throw error;
  }
  return { data, status: response.status };
};

export const verifyCode = async (email, code) => {
  const response = await fetch(`${baseUrl}/api/v1/attnd-supplier/auth/verify-code`, {
    method: "POST",
    credentials: "include",
    headers: defaultHeaders(),
    body: JSON.stringify({ email, code }),
  });
  const data = await response.json();
  if (!response.ok) {
    const error = new Error("Verification failed");
    error.response = data;
    throw error;
  }
  return data;
};

export const resetPassword = async (values) => {
  const response = await fetch(`${baseUrl}/api/v1/attnd-supplier/auth/reset-password`, {
    method: "POST",
    credentials: "include",
    headers: defaultHeaders(),
    body: JSON.stringify(values),
  });
  const data = await response.json();
  if (!response.ok) {
    const error = new Error("Reset password failed");
    error.response = data;
    throw error;
  }
  return { data, status: response.status };
};

export const resendCode = async (email) => {
  const response = await fetch(`${baseUrl}/api/v1/attnd-supplier/auth/forget-password`, {
    method: "POST",
    credentials: "include",
    headers: defaultHeaders(),
    body: JSON.stringify({ email }),
  });
  const data = await response.json();
  if (!response.ok) {
    const error = new Error("Resend code failed");
    error.response = data;
    throw error;
  }
  return { data, status: response.status };
};